export default __webpack_public_path__ + "static/media/M30S.c8ea6519.png";